import { render, staticRenderFns } from "./ArticleHeader.vue?vue&type=template&id=14cef7c4&scoped=true"
import script from "./ArticleHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./ArticleHeader.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ArticleHeader.vue?vue&type=style&index=0&id=14cef7c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cef7c4",
  null
  
)

export default component.exports